import React from "react";
import classes from "./adaptivecontainer.module.css";
import cn from "classnames";

export default function Container({className, ...props}: React.ComponentProps<"div">) {
  return <div className={cn(classes.root, className)} {...props}/>
}
